import { ErrorComponent, type ErrorComponentProps } from '@tanstack/react-router';
import { AccessDenied } from '@/components/custom/access-denied';
import { isForbiddenError } from '@/lib/http-errors';

export function RouteErrorComponent({ error, ...props }: ErrorComponentProps) {
  if (isForbiddenError(error)) {
    return <AccessDenied />;
  }
  return <ErrorComponent error={error} {...props} />;
}
